import {
  useAppSelector,
  useAppDispatch,
  setSelectedPlantId,
} from '@energy-stacks/fleet/store';
import { useEffect } from 'react';
import { useGetPlantIdsQuery } from '@energy-stacks/fleet/feature-business-accounts-data';

export const useSelectPlantIds = () => {
  const dispatch = useAppDispatch();
  const selectedPlantId = useAppSelector(
    (state) => state.plant.selectedPlantId
  );
  const { data: plantIds, isLoading, isError } = useGetPlantIdsQuery();

  useEffect(() => {
    if (isError) {
      dispatch(setSelectedPlantId(null));
    }
  }, [dispatch, isError]);

  useEffect(() => {
    if (!plantIds) {
      return;
    }

    if (plantIds.length > 0) {
      // If there is no selectedPlantId persisted in the store, select the first plantId
      if (!selectedPlantId) {
        dispatch(setSelectedPlantId(plantIds[0]));
        return;
      }

      // If there is selectedPlantId but it's not in the list of plantIds, select the first plantId
      if (!plantIds.find((plantId) => plantId === selectedPlantId)) {
        dispatch(setSelectedPlantId(plantIds[0]));
      }
    }
  }, [dispatch, plantIds, selectedPlantId]);

  return { isLoadingPlantIds: isLoading, isError };
};
